
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";

export function minimapButtonClicked() {
    BpmnJsCliWrapper.openMinimap();
}
